// Same bell pattern the food pantry check-in alert plays.
let ctxRef = null;

export const playCheckInBell = async () => {
  try {
    if (!ctxRef) ctxRef = new (window.AudioContext || window.webkitAudioContext)();
    if (ctxRef.state === 'suspended') await ctxRef.resume().catch(() => {});
    const ctx = ctxRef;
    const now = ctx.currentTime;
    const tone = (frequency, startTime, duration, volume = 0.8) => {
      const osc = ctx.createOscillator();
      const osc2 = ctx.createOscillator();
      const gain = ctx.createGain();
      const gain2 = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = frequency;
      osc.type = 'sine';
      osc2.connect(gain2);
      gain2.connect(ctx.destination);
      osc2.frequency.value = frequency * 2.5;
      osc2.type = 'sine';
      gain.gain.setValueAtTime(volume, startTime);
      gain.gain.exponentialRampToValueAtTime(volume * 0.7, startTime + 0.05);
      gain.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
      gain2.gain.setValueAtTime(volume * 0.3, startTime);
      gain2.gain.exponentialRampToValueAtTime(0.01, startTime + duration * 0.7);
      osc.start(startTime);
      osc.stop(startTime + duration);
      osc2.start(startTime);
      osc2.stop(startTime + duration);
    };
    tone(830, now, 0.5, 0.9);
    tone(622, now + 0.15, 0.5, 0.9);
    tone(830, now + 0.3, 0.6, 0.9);
    tone(1046, now + 0.5, 0.8, 1.0);
  } catch (e) {
    console.error('Failed to play bell:', e);
  }
};
